import { DatePipe, TitleCasePipe } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core/src/translate.service";
import { Modal } from "ngx-modal";
import { environment } from "../../../../environments/environment";
import { AccessLevel } from "../../../common/enums/access-level.enum";
import { AccountRestrictionStatus } from "../../../common/enums/account-restricted.enum";
import { Permission } from "../../../common/enums/permission.enum";
import { DistributorIdFormatPipe } from "../../../common/pipes/distributor-id-format.pipe";
import { MemberActivityLogType } from "../../../shared/common/enumerations";
import { CommonService } from "../../../shared/services/common.service";
import { MessageService } from "../../../shared/services/message.service";
import { CommonMessage } from "../../common/common-messages";
import { AttachmentType, MemberType,Constants } from "../../common/constants";
import { MergeredCountries } from "../../enums/countries.enums";
import { AccountDetails } from "../../interface/account-details";
import { ActivityLogKey } from "../../interface/activityLogKey";
import { CountryList } from "../../interface/country-data";
import { DistributorDetails } from "../../interface/distributor-details";
import { OrderHistoryDetails } from "../../interface/order-history-details";
import { DeleteModal } from "../../models/delete-modal";
import { CustomerService } from "../../services/customer.service";
import { UplineReportService } from "../../services/upline-report.service";



@Component({
    selector: "upline",
    templateUrl: "../../templates/template1/views/reports/upline-report.component.html",
    styleUrls: ["../../templates/template1/themes/default/css/upline-report.component.less"],
    providers: [TitleCasePipe, DistributorIdFormatPipe, UplineReportService]
})

export class UplineReportComponent implements OnInit {

    @Input() fboid: string;
    @Input() homeCountryInfo: string;
    @ViewChild('accountdetails') accountDetailsModalPopup: Modal;
    @ViewChild('accountorderhistory') accountOrderHistoryModalPopup: Modal;
    firstname: string;
    lastname: string;
    homeCountryCode: string;
    mydate: string;
    titlecase: any;
    distributorIdFormat: any;
    operatingCountries: CountryList[] = [];
    country: string;
    accountName: string;
    upLineDistributorDetails: DistributorDetails[] = [];
    totalUpLineDistributorDetails: DistributorDetails[] = [];
    accountDetails: AccountDetails;
    orderHistoryDetails: OrderHistoryDetails[] = [];
    totalOrderHistoryDetails: OrderHistoryDetails[] = [];
    sortColumn: string = "orderplaceddate";
    sort: String = "DESC";
    FBODetailPermissions: any[] = [Permission.FBO_PROFILE_VIEW, Permission.FBO_ORDER_HISTORY_VIEW,
        Permission.FBO_AUTOSHIP_DETAILS_VIEW, Permission.FBO_PAYMENT_METHODS_VIEW,
        Permission.FBO_DOWNLINE_VIEW, Permission.FBO_REPORTS_VIEW, Permission.MANAGE_TICKETS_VIEW];
        deleteModal: DeleteModal;
    recentOrderHistorySort: String = "DESC";
    sortRecentOrderHistoryColumn: string = "orderplaceddate";
    isRecentOrderHistoryDesc: Boolean = true;
    pageNumber: number = 1;
    pageSize: number = 10;
    pageCount: number = 0;
    recentpageCount: number = 0;
    recentpageNumber: number = 1;
    recentpageSize: number = 10;
    show: Boolean = true;
    isRecentView: Boolean = false;
    totalCount: number;
    disableExport = false;
    uplineSortColumn: string = "rowNumber";
    uplineSort: String = "DESC";
    recentUplineSort: String = "DESC";
    sortRecentUplineColumn: string = "rowNumber";
    isRecentUplineDesc: Boolean = true;
    uplinePageNumber: number = 1;
    uplinePageSize: number = 25;
    uplinePageCount: number = 0;
    uplineRecentpageCount: number = 0;
    uplineRecentpageNumber: number = 1;
    uplineRecentpageSize: number = 25;
    showUpline: Boolean = true;
    iUplineView: Boolean = false;
    uplineTotalCount: number;

    memberId: number;

    searchTerm: any = '';
    selectedCountry: any = [];
    excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
    pdfIconUrl = environment.cdnURL + '/flpi/images/pdf_icon.png';

    selectedHomeCompany:any = {};
    selectedHomeCountryValue:any;
    homeCompanyData = [
        { operatingCompany: "FRA", countryDisplayName: "France" },
        { operatingCompany: "ESP", countryDisplayName: "Spain" },
        { operatingCompany: "PRT", countryDisplayName: "Portugal" }
    ];
    accountViewPermission: boolean = false;
    accountRestrictionPermission: any[] = [Permission.ACCOUNT_RESTRICTED_VIEW, Permission.ACCOUNT_RESTRICTED_MANAGE];
    accountRestriction: boolean;
    memberDetails: { fboId: any; firstName: string; };

    constructor(private _customerservice: CustomerService,
        private _uplineService: UplineReportService,
        private _datePipe: DatePipe,
        private _titleCasePipe: TitleCasePipe,
        private _distributorIdFormatPipe: DistributorIdFormatPipe,
        private _translateService: TranslateService
        ,private _commonService: CommonService,        
        private messageService: MessageService
    ) { }

    ngOnInit(): void {
        this.fboid ? this.getMemberInfo() : '';
        this.homeCountryCode = this.homeCountryInfo;
        this.getCountries(this.fboid, this.homeCountryCode);
        // this.getRecentUplineReportDetails();
        this.mydate = this._datePipe.transform(new Date(), 'dd-MMM-yyyy');
        this.distributorIdFormat = this._distributorIdFormatPipe.transform(this.fboid);
        this.accountViewPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.accountRestrictionPermission[0] + ']'), AccessLevel.Customer_Service);
    }


/**
 * 
 * @param countryValue set drop down values based on homeCountryCode
 */
    setDropdownValuesHomeCompany(homeCountryCode) {
        const homeCompanyCode = homeCountryCode ? this.homeCompanyData.find(homeCompany => homeCompany.operatingCompany.toUpperCase() == homeCountryCode.toUpperCase()) :'';
        this.selectedHomeCompany = homeCompanyCode;
        this.selectedHomeCountryValue = homeCompanyCode? homeCompanyCode.operatingCompany:'';
    }

    /**
     * get member Info
     */
    getMemberInfo() {
        this._customerservice.getMemberInformationFromTitan(this.fboid).subscribe(response => {
            if (response && response.isSuccess) {
                this.memberId = response.memberId;
                this.firstname = response.firstName;
                this.lastname = response.lastName;
                // this.homeCountryCode = response.homeCountryCode;

            } else {

            }
        });
    }

    navigateToFBOProfile(id: any, memberType: string, name: string) {

        this.closePopUpforAccountDetails();
        // verifying permissions - whether any one of the permission exists for logged in user.
        var isAuthorized = this._commonService.checkPermissionByAccessLevel(this.FBODetailPermissions,AccessLevel.Customer_Service);
        if (isAuthorized) {
            let fboInfo = { id: id, tabName: this.accountName, componentName: 'fboPage', memberType: MemberType.FOB };
            this.messageService.setCustomerServiceTabContent(fboInfo);
        }
        else {
            this.displayAlertbox();
        }
    }


    displayAlertbox() {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    }
    /**
    * getCountries Method used to get the country list
    * @param  {number} distributorId
    * @returns void
    */
    getCountries(distributorId: string, homeCountry: string): void {
        if (distributorId && homeCountry) {
            this._commonService
                .getCountries(distributorId, homeCountry)
                .subscribe(res => {
                    if (res) {
                        let selectOperatingCountry = [];
                        res.forEach((element: any) => {                            
                            let country: CountryList = { name: '', value: ''};
                            country.name = element.countryName;
                            country.value = element.operatingCompany;
                            country.disabled = false;
                            if(country.value.toUpperCase() == MergeredCountries.ESP.toUpperCase() || country.value.toUpperCase() ==MergeredCountries.PRT.toUpperCase() ){
                                country.name = country.name+' '+Constants.NOT_AVAILABLE_PLEASE_SELECT_FRANCE
                                country.disabled = true
                            }
                            if (element.homeCountry === true || element.homeCountry === 'true') {
                                selectOperatingCountry.push(country);                         
                            }
                            this.operatingCountries.push(country);
                        })
                                   
                        if (selectOperatingCountry.length > 0) {
                            selectOperatingCountry.forEach(operatingCountry => {
                                if (operatingCountry.value.toUpperCase() == MergeredCountries.FRA.toUpperCase() ||
                                    operatingCountry.value.toUpperCase() == MergeredCountries.ESP.toUpperCase() ||
                                    operatingCountry.value.toUpperCase() == MergeredCountries.PRT.toUpperCase()) {
                                    const OpCoDropdownValues = selectOperatingCountry.find(country => country.value.toUpperCase() == MergeredCountries.FRA.toUpperCase());
                                    this.selectedCountry = OpCoDropdownValues;
                                    this.country = this.selectedCountry.value;
                                }
                                else {
                                    this.selectedCountry = operatingCountry;
                                    this.country = this.selectedCountry.value;
                                }
                            })
                            if(this.country && this.country.toUpperCase() == MergeredCountries.FRA.toUpperCase()) {
                                if (this.homeCountryCode.toUpperCase() == MergeredCountries.ESP.toUpperCase() ||
                                    this.homeCountryCode.toUpperCase() == MergeredCountries.PRT.toUpperCase()) {
                                    this.setDropdownValuesHomeCompany(this.homeCountryCode);
                                }
                                else {
                                    this.setDropdownValuesHomeCompany(this.country);
                                }
                            } 
                            else {
                                this.selectedHomeCountryValue='';                
                            }
                        }                        
                    }
                    this.getRecentUplineReportDetails();
                });
            }
        }


    getChangeCountries(value: string): void {
        if (this.fboid && value) {
            this.country = value;
            if(this.country.toUpperCase() == MergeredCountries.FRA.toUpperCase()) {
            if(this.homeCountryCode.toUpperCase() == MergeredCountries.ESP.toUpperCase() || 
            this.homeCountryCode.toUpperCase() == MergeredCountries.PRT.toUpperCase())  { 
                this.setDropdownValuesHomeCompany(this.homeCountryCode); 
            }else{
                this.setDropdownValuesHomeCompany(this.country);
            }        
            }else{
                this.selectedHomeCountryValue='';                
            }
            this.getRecentUplineReportDetails();                       
        }
    }

    getChangeHomeCountry(value: string){
        this.selectedHomeCountryValue = value;
        this.getRecentUplineReportDetails();
    }
    // getUplineDetails(distributorId: string, homeCountry: string): void {
    //     if (distributorId && homeCountry) {
    //         this._uplineService
    //         .getUplineDetails(this.fboid, this.homeCountryCode, this.uplineRecentpageNumber,
    //             this.uplineRecentpageSize, this.recentUplineSort, sortOrder)
    //             .subscribe(res => {
    //                 this.upLineDistributorDetails = res;
    //                 // this.upLineDistributorDetails = _.orderBy(this.upLineDistributorDetails, ['rowNumber'], ['desc']);
    //             });
    //     }
    // }

    getAccountDetails(distributorId: any, homeCountry: string, name?: string, memberLevel?: string) {
        this._commonService.getMemberStatus(distributorId).subscribe(response => {
            if( response && response.status === AccountRestrictionStatus.RESTRICTED && !this.accountViewPermission){
                this.accountRestriction = true;
                const memberDetails = {
                    fboId: distributorId,
                    firstName: name,
                    memberLevel: memberLevel
                };
                this.memberDetails = memberDetails; 
            } else {
                this.getReportsAccountDetail(distributorId, homeCountry);
            }
        })
    }

    closeModal(status: boolean){
        this.accountRestriction = status;
    }

    getReportsAccountDetail(distributorId: any, homeCountry: string){
        if (distributorId && homeCountry) {
            this._uplineService
                .getAccountDetails(distributorId, homeCountry)
                .subscribe(res => {
                    if (res) {
                        this.accountDetails = res;
                       var fullName= this.accountDetails.name.split(/[,]/);
                       this.accountName= fullName[1] + ' ' +fullName[0].charAt(0).toUpperCase() + fullName[0].slice(1);
                        this.accountDetailsModalPopup.open();
                    }
                })

        }
    }

    closePopUpforAccountDetails(): void {
        this.accountDetailsModalPopup.close();
    }

    // getOrderHistoryDetails(distributorId: string, homeCountry: string){
    //     if (distributorId && homeCountry) {
    //         this._uplineService
    //             .getOrderHistoryDetails(distributorId,homeCountry)
    //             .subscribe(res => {
    //                 if (res) {
    //                     this.orderHistoryDetails = res;
    //                     this.accountOrderHistoryModalPopup.open();
    //                 }
    //             })
    //     }
    // }

    closePopUpforAccountOrderHistoryDetails = () => {
        this.accountOrderHistoryModalPopup.close();
    }

    recentOrderHistoryPageChange(recentpageNumber: number) {
        if (!isNaN(recentpageNumber)) {
            this.recentpageNumber = recentpageNumber;
            this.getRecentOrderHistoryDetails();
        }
    }


    recentUplineReportPageChange(uplineRecentpageNumber: number) {
        if (!isNaN(uplineRecentpageNumber)) {
            this.uplineRecentpageNumber = uplineRecentpageNumber;
            // this.getRecentUplineReportDetails();
        }
    }


    sortUplineReportDetailsByColumn(uplineSortColumn: string) {
        this.uplineRecentpageNumber = 1;
        this.isRecentUplineDesc = (this.sortRecentUplineColumn == uplineSortColumn) ? !this.isRecentUplineDesc : true;
        this.recentUplineSort = this.isRecentUplineDesc ? 'DESC' : 'ASC';
        this.sortRecentUplineColumn = uplineSortColumn;
        // added this condition not to hit service if there are no items in grid.
        if (this.upLineDistributorDetails.length === 0) {
            return;
        }
        this.getRecentUplineReportDetails();
    }


    getRecentUplineReportDetails() { 
        if (this.fboid) {
            const sortOrder = [];
            sortOrder.push(this.sortRecentUplineColumn);
            this.showUpline = true;
            this._uplineService
                .getUplineDetails(this.fboid, this.country, this.uplineRecentpageNumber,
                    this.uplineRecentpageSize, this.recentUplineSort, sortOrder, this.searchTerm,this.selectedHomeCountryValue)
                .subscribe(response => {
                    if (response) {
                        this.uplineTotalCount = response['totalCount'];
                        this.uplineTotalCount ? this.uplineRecentpageCount = this.uplineTotalCount : '';
                        this.upLineDistributorDetails = response['upLineDistributorDetailsModels'];
                        this.isRecentView = false;
                        if(this.upLineDistributorDetails.length === 0){
                        this.disableExport = true;}
                        else{
                            this.disableExport = false;
                        }
                    }
                    else {
                        this.uplineRecentpageCount = 0;
                        this.upLineDistributorDetails = new Array<DistributorDetails>();
                        // this.disableExport = false;
                    }
                    this.showUpline = false;
                });

        }
    }

    sortOrderHistoryDetailsByColumn(sortColumn: string) {
        this.recentpageNumber = 1;
        this.isRecentOrderHistoryDesc = (this.sortRecentOrderHistoryColumn == sortColumn) ? !this.isRecentOrderHistoryDesc : true;
        this.recentOrderHistorySort = this.isRecentOrderHistoryDesc ? 'DESC' : 'ASC';
        this.sortRecentOrderHistoryColumn = sortColumn;
        // added this condition not to hit service if there are no items in grid.
        if (this.orderHistoryDetails.length === 0) {
            return;
        }
        this.getRecentOrderHistoryDetails();
    }

    getRecentOrderHistoryDetails() {
        if (this.accountDetails.distributorId) {
            const sortOrder = [];
            sortOrder.push(this.sortRecentOrderHistoryColumn);
            this.show = true;
            this._uplineService
                .getRecentOrderHistoryDetails(this.accountDetails.distributorId, this.accountDetails.homeCountry, this.recentpageNumber,
                    this.recentpageSize, this.recentOrderHistorySort, sortOrder)
                .subscribe(response => {
                    if (response) {
                        this.totalCount = response['totalCount'];
                        this.totalCount ? this.recentpageCount = this.totalCount : '';
                        this.orderHistoryDetails = response['distributorOrdersModels'];
                        this.isRecentView = false;
                        this.accountOrderHistoryModalPopup.open();
                    }
                    else {
                        this.recentpageCount = 0;
                        this.orderHistoryDetails = new Array<OrderHistoryDetails>();
                    }
                    this.show = false;
                });
        }
    }

    // form data to download to pdf/ csv/print

    Download(type: string) {
        if (this.disableExport === false) {
        this.fetchUplineData(true, type);}
    }

    /* 
    get total data without pagination
    */
    fetchUplineData(fetchAllrecords: boolean, type: string) {
        const sortOrder = [];
        let recentOrdersInfo: any;
        sortOrder.push(this.sortRecentUplineColumn);
        this._uplineService
            .getUplineDetails(this.fboid, this.country, this.uplineRecentpageNumber,
                this.uplineRecentpageSize, this.recentUplineSort, sortOrder, this.searchTerm)
            .subscribe(response => {
                if (response) {
                    this.totalUpLineDistributorDetails = response['upLineDistributorDetailsModels'];
                } else {
                    this.totalUpLineDistributorDetails = new Array<DistributorDetails>();
                }
                // this.totalUpLineDistributorDetails = _.orderBy(this.upLineDistributorDetails, ['rowNumber'], ['desc']);
                this.generatePDFOrExcel(type);
            });
    }

    generatePDFOrExcel(type: string): void {

        var removeKeys = ["rowNumber", "distributorId", "name", "state", "operatingCompanyCode", "level", "currentMonthActive", "distributorStatus"];

        var columns = [
            '#',
            this._translateService.get('uplinereport.ID')['value'],
            this._translateService.get('uplinereport.FBO Name')['value'],
            this._translateService.get('uplinereport.State')['value'],
            this._translateService.get('uplinereport.Home Country')['value'],
            this._translateService.get('uplinereport.Level')['value'],
            this._translateService.get('uplinereport.4CC Active?')['value'],
            this._translateService.get('uplinereport.Status')['value'],
        ];
        let rowdata = new Array<any>();
        let finalrows = new Array<any>();
        let distId: string;
        let distributorIdWithFormat: string;
        if (this.totalUpLineDistributorDetails) {
            for (let i = 0; i < this.totalUpLineDistributorDetails.length; i++) {
                rowdata = [];
                var orderHistory = this.totalUpLineDistributorDetails[i];
                Object.keys(orderHistory).map(function (k) {
                    if (k == "rowNumber")
                        rowdata.push(orderHistory[k]);
                    else if (k == "distributorId") {
                        distId = orderHistory[k];
                        // distributorIdWithFormat = this._distributorIdFormatPipe.transform(distId);
                        distributorIdWithFormat = distId.substring(0, 3)
                            + '-' + distId.substring(3, 6) + '-'
                            + distId.substring(6, 9) + '-' + distId.substring(9, 12);
                        rowdata.push(distributorIdWithFormat);
                    }
                    else if (k == "name")
                        rowdata.push(orderHistory[k]);
                    else if (k == "state")
                        rowdata.push(orderHistory[k]);
                    else if (k == "operatingCompanyCode")
                        rowdata.push(orderHistory[k]);
                    else if (k == "level")
                        rowdata.push(orderHistory[k]);
                    else if (k == "currentMonthActive")
                        rowdata.push(orderHistory[k] ? (orderHistory[k] == 'true' ? 'Yes' : 'No')  : 'No' );
                    else if (k == "distributorStatus")
                        rowdata.push(orderHistory[k]);
                });
                finalrows.push(rowdata);
            }

            const title = this._translateService.get('uplinereport.Upline Report')['value'];
            if (type == "PDF") {
                this._customerservice.PdfDownload(columns, finalrows, title + "_" + this.fboid, title);
                const activityLogKeys: ActivityLogKey[] = [{
                    key: MemberActivityLogType.Upline_Report_Attachment,
                    value: title + "_" + this.fboid +  ' ' + AttachmentType.PDF
                  }];
                if (this.memberId) {
                    this._commonService.saveMemberActivity(this.memberId, activityLogKeys).subscribe();
                }
            }
            else if (type == "CSV")
            {
                this._customerservice.ExcelDownload(columns, finalrows, title + "_" + this.fboid, title);

                const activityLogKeys: ActivityLogKey[] = [{
                    key: MemberActivityLogType.Upline_Report_Attachment,
                    value: title + "_" + this.fboid + ' ' + AttachmentType.CSV
                  }];
                if (this.memberId) {
                    this._commonService.saveMemberActivity(this.memberId, activityLogKeys).subscribe();
                }
            }

            let table: string = "<table  style='border:solid 1px;'>";
            let thead: string = "<thead>";
            let tbody: string = "<tbody>";
            let trow: string = "";
            let totalRows: string = "";

            columns.forEach((element) => {
                thead = thead + " <th style='border:solid 1px;  word-wrap:break-word;'> " + element + "</th>";
            });
            Object.keys(finalrows).forEach(key => {
                trow = "<tr>";
                for (let j = 0; j <= finalrows[key].length - 1; j++) {
                    trow = trow + "<td style='border:solid 1px;  word-wrap:break-word;'>" + finalrows[key][j] + "</td>";
                }
                totalRows = totalRows + trow + "</tr>";

            });

            thead = thead + "</thead>";
            tbody = tbody + totalRows + "</tbody>";

            table = table + thead + tbody + "</table>";
            // this.print(table, title);
        }
    }

    print(data: any, title: string) {
        var printWindow = window.open('', '', 'height=400,width=800');
        printWindow.document.write('<html><head><title>' + title + '</title>');
        printWindow.document.write('</head><body >');
        printWindow.document.write(data);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();

    }

    searchUplineReportDetais() {
        this.getRecentUplineReportDetails();
    }

    clearFields() {
        this.searchTerm = '';
        this.getRecentUplineReportDetails();
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/upline-report.component.ts